
const digest = '34d0e336d6fde4bd553a848e9765e570362f2658488d0263d065b5af02187da0';
const classes = {"wrapper":"_wrapper_1ckmy_1","icon":"_icon_1ckmy_8","text":"_text_1ckmy_17"};
const css = `._wrapper_1ckmy_1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 8px;
  cursor: pointer;
}
._wrapper_1ckmy_1 ._icon_1ckmy_8 {
  height: 64px;
  width: 64px;
  background-color: #fff;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
._wrapper_1ckmy_1 ._text_1ckmy_17 {
  color: #ffffff;
  font-size: 12px;
  text-decoration: underline;
  margin-top: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  